<!--
센터 > 기본운임설정
------------------------------------
-->
<template>
    <!-- 폼 화면 -->

    <div class="confirm-overlay" ref="confirm-overlay" v-show="display">
        <div class="confirm-dialog p-1rem">


            <div class="mt-1rem uk-flex uk-flex-between uk-flex-bottom">
                <div class="font-bold text-black">
                    센터 기본운임 설정
                </div>

            </div>

            <table class="info-table small uk-width-1-1 border-highlight mt-1rem">
                <colgroup>
                    <col style="width: 9rem">
                    <col>
                </colgroup>

                <tr v-if="region">
                    <th class="uk-text-right">
                        센터
                    </th>
                    <td>
                        <img :src="region.flag16"/>
                        {{ region.name }}
                    </td>

                </tr>

                <tr>
                    <th class="uk-text-right">
                        기본운임
                    </th>
                    <td>
                        <app-input-search-select
                            multiselect-class="large-height"

                            :options="shippingCostTableOptions"
                            v-model="inputs.table_id"

                            placeholder="기본 운임을 선택하세요."

                        ></app-input-search-select>
                    </td>

                </tr>




            </table>

            <div class="uk-text-right mt-1rem">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default"

                    @click="hideForm"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>


                <button
                    type="button"
                    class="uk-button uk-button-primary"

                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>

        </div>
    </div>

</template>

<script>

import regionAble from "../common/region-able.vue";

export default {
    mixins: [
        regionAble,
    ],
    props: {
        // csrf-token
        csrfToken: String,
    },
    data: function () {
        return {
            // (bool) 폼 display 여부
            display: false,

            // (object) 영업소 정보
            agent: {},

            // (array) 운임표 옵션
            shippingCostTableOptions: [],

            /**
             * 입력값
             */
            inputs: {
                table_id: null,
            },
        };
    },
    mounted: function () {
        //console.log('mounted in component');
    },
    computed: {
        /**
         * 지역
         * @return object
         */
        region() {
            return this.get_region(this.agent.region_id);
        },
    },
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            document.body.appendChild(this.$refs['confirm-overlay']);
            this.display = true;
        },

        /**
         * 입력폼 hide
         */
        hideForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            this.display = false;
        },

        /**
         * 폼 띄우기
         */
        form(agent_id) {
            // 초기화
            this.inputs = {
                table_id: null,
            };

            // promise 생성
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/agents/' + agent_id,
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            });


            // promise 처리
            load.then((response) => {
                this.agent = response.agent;
                this.shippingCostTableOptions = response.shipping_cost_table_options;

                // 입력값 설정
                this.inputs.table_id = this.agent.default_shipping_cost_table;

                //console.log(response);
                // 폼띄우기
                this.displayForm();
            });
        },

        /**
         * 서브밋 전 검증
         * @return Promise
         */
        submitValidation() {
            return new Promise((resolve, reject) => {
                // 입력값 검증
                /*
                if (! this.inputs.table_id) {
                    reject('운임을 선택하세요.');
                    return;
                }
                 */

                resolve();
            });


        },

        /**
         * submit
         */
        submit() {
            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/agents/' + this.agent.id + '/default-shipping-cost-table',
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // 완료이벤트
                    this.$emit('done');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },

        /**
         * 요청취소
         */
        cancel() {
            // 컨펌
            if (! confirm('입금확인 요청을 취소하시겠습니까?')) {
                return;
            }

            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/agents/' + this.agent.id + '/default-shipping-cost-table',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // 요청취소 완료 이벤트
                    this.$emit('canceled');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },
    },
}
</script>

<style lang="scss" scoped>


// 컨펌화면
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .confirm-dialog {
        width: 70rem;
        max-width: 90%;

        background-color: #fff;

    }
}
</style>